export const ALPHABETICAL = {
    id: 1,
    name: 'Alphabetical',
    value: 'ALPHABETICAL',
};
export const RECENTALY_UPDATED = {
    id: 2,
    name: 'Recently Updated On Top',
    value: 'RECENTALY_UPDATED',
};
export const SEQUENCE = {
    id: 3,
    name: 'Sequence',
    value: 'SEQUENCE',
};
export const Basic = [ALPHABETICAL, RECENTALY_UPDATED, SEQUENCE];
export const BasicByValue = Basic.reduce((hash, type) => {
    hash[type.value] = type;
    return hash;
}, {});
export const BasicValues = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicValues,
    ALPHABETICAL,
    RECENTALY_UPDATED,
    SEQUENCE,
};
